import { LitElement, html, nothing, css } from 'lit'
import { property, customElement } from 'lit/decorators.js'
import type { IconName } from './helpers/icons'

@customElement('zaptic-centered-message')
export class CenteredMessage extends LitElement {
    static styles = css`
        :host {
            height: 100%;
        }

        .CenteredMessage {
            align-items: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
            margin: var(--zaptic-centered-message-margin, 0 30px);
        }

        .CenteredMessage__content {
            font-size: var(--zaptic-centered-message-font-size, 14px);
            font-weight: var(--font-weight-regular);
            margin: 20px 0 0;
            text-align: center;
        }

        .CenteredMessage__heading {
            color: var(--zaptic-centered-message-heading-color, var(--grey-700));
            font-size: var(--zaptic-centered-message-heading-font-size, 18px);
            font-weight: var(--zaptic-centered-message-heading-font-weight, var(--font-weight-medium));
            line-height: 24px;
            margin: 0;
        }

        .CenteredMessage__message {
            color: var(--zaptic-centered-message-color, var(--grey3));
            line-height: 20px;
            margin: 4px 0 0;
            max-width: var(--zaptic-centered-message-max-width, none);
            white-space: pre-line;
        }
    `

    @property()
    heading = ''

    @property()
    message = ''

    @property()
    iconName?: IconName

    renderIcon() {
        return html`
            <div class="CenteredMessage__icon">
                <zaptic-icon icon-name="${this.iconName}"></zaptic-icon>
            </div>
        `
    }

    render() {
        return html`
            <div class="CenteredMessage">
                <slot></slot>
                ${this.iconName && this.renderIcon()}

                <div class="CenteredMessage__content">
                    ${this.heading
                        ? html`<h3 class="CenteredMessage__heading">${window.i18n(this.heading)}</h3>`
                        : nothing}

                    <!-- Needs to stay all in one line to avoid gaps in the rendered text -->
                    <p class="CenteredMessage__message"><slot name="message">${window.i18n(this.message)}</slot></p>
                </div>
            </div>
        `
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'zaptic-centered-message': CenteredMessage
    }
}
